import { ISummaryTableProps } from "./SummaryTable";

export const View = (props: ISummaryTableProps) => {
  return (
    <section>
      <div className="summary-container">
        <h5>{props.Title}</h5>
        <table>
          <h1></h1>

          {props.data.map((val, key) => {
            return (
              <tr key={key}>
                <td>{val.key}</td>
                <td> {val.value}</td>
                <td> {">"}</td>
              </tr>
            );
          })}
          <h1></h1>
        </table>
      </div>
    </section>
  );
};
